export default "__VITE_ASSET__9d5f86f2__"